export default "__VITE_ASSET__f9f34e50__"